import "jquery-confirm";
import "jquery-confirm/css/jquery-confirm.css"
import {getCookie, setCookie, deleteCookie} from "./modules/cookie";

$('#login_fm').on("submit",function (e) {
    e.preventDefault();
    let data = $("#login_fm").serialize();
    $.ajax({
        type: "post",
        url: "/api/auth/login",
        data: data,
        dataType: 'json',
        success: function (response) {
            if (response.code === "OK") {
                // if (response.menu === "dashboard") {
                location.href="/dashboard/list";
                // } else {
                //     location.href="/dbms/list";
                // }
            } else {
                $.alert({
                    icon: 'fa fa-exclamation-circle',
                    theme: 'material',
                    closeIcon: true,
                    animation: 'scale',
                    type: 'dark',
                    title: '오류!',
                    content: response.message,
                });
            }
        },
    });
});


let  user_id = getCookie("user_id");
$("input[name='user_id']").val(user_id);
if($("input[name='user_id']").val() !== "") $("#remember_me").attr("checked", true);
$("#remember_me").on("change", function(){
    if($("#remember_me").is(":checked")){
        let user_id = $("input[name='user_id']").val();
        setCookie("user_id", user_id, 30);
    }else{
        deleteCookie("user_id");
    }
});
